export const convertNewLinesToBr = (str: string) => str.split('\n').join('<br/>');
